<template>
  <div>
    <section class="banner-sec bg bg-9">
      <div class="container">
        <div class="bg-content">
          <div class="box-login">
            <h1 class="lato">Recuperar contraseña</h1>
            <form class="form login-form">    
              <div class="box-success" v-if="respuesta">
                <b>Listo!</b> Te enviamos un mail para que puedas recupererar tu clave.
                <br>
                <router-link class="btn-link deco-dotted pull-right" to="/login">INGRESAR AL SISTEMA</router-link>
              </div>
              <div class="clearfix"></div>
              <div class="form-group">
                <label>Ingresa el correo con el que se registró</label>
                <input type="mail" v-model="email" class="form-control"/>
              </div>
              <div class="form-action">
                <router-link to="/login" class="btn-link deco-dotted pull-left">¿YA TIENES UNA CUENTA?</router-link>
                <button type="button" class="btn btn-fill btn-lg size-16" @click.prevent="clickEnviar">ENVIAR</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import $ from 'jquery'
  export default {
    data () {
      return {
        email: '',
        mostrarErrores: false,
        respuesta: false
      }
    },
    methods: {
      clickEnviar () {
        const me = this
        me.$http.post('/api/users/recuperar', {
          email: me.email
        }).then(({body}) => {
          me.email = ''
          me.respuesta = true
        }, (err) => {
          console.error(err)
        })
      }
    },
    mounted () {
      $('html, body').animate({ scrollTop: 0 }, 'slow')
    }
  }
</script>



// WEBPACK FOOTER //
// Recuperar.vue?63e01bce